import { Dexie, type EntityTable } from "dexie";

export type AiAgentTestVariablesRecord = {
    key: string;
    config: Record<string, unknown>;
};

/**
 * High storage limit local Database. Can get easily cleared by the user, so nothing important/persistent should be stored here.
 * Let's keep all the stores and configs in this file to make sure it doesn't get big and messy.
 */
export const regalLocalDB = new Dexie("regalLocalDB") as Dexie & {
    aiAgentTestVariables: EntityTable<AiAgentTestVariablesRecord, "key">;
};

regalLocalDB.version(1).stores({
    aiAgentTestVariables: "key, config",
});
